import PerfectScrollbar from 'perfect-scrollbar';

export const initScrollBars = () => {
    const blocks = Array.from(document.querySelectorAll('.js-scrollbar-block'));

    blocks.forEach((block) => {
        // eslint-disable-next-line no-unused-vars
        const ps = new PerfectScrollbar(block, {
            suppressScrollX: true,
            scrollYMarginOffset: 5
        });
    });
};
